// BHP-1038: migrated from the legacy Bootstrap public Layout to the Tailwind
// AuthLayout (reference screen for the new design system).
import AuthLayout from '../../shared/ui/AuthLayout';
import { useAuth } from 'react-oidc-context';

const Login = (): JSX.Element => {
  const auth = useAuth();

  return (
    <AuthLayout title="Login to your account">
      {auth.isAuthenticated ? (
        <p className="text-center text-sm text-ink-muted">
          Signed in — redirecting…
        </p>
      ) : (
        <button
          type="button"
          onClick={() => {
            void auth.signinRedirect();
          }}
          disabled={auth.isLoading}
          className="w-full rounded-md bg-brand px-4 py-2 font-medium text-ink-inverse transition-colors hover:bg-brand-dark disabled:opacity-60"
        >
          {auth.isLoading ? 'Signing in…' : 'Sign In'}
        </button>
      )}
    </AuthLayout>
  );
};
export default Login;
